import Vue from 'vue'
/**
 * Include Vue
 * Assign vue to the window
 */
window.Vue = Vue;

/**
 * Require polyfill for IE10 and IE11
 * https://github.com/JeffreyWay/laravel-mix/issues/436
 */
require("@babel/polyfill");

if (typeof Promise === "undefined") {
  require("promise/lib/rejection-tracking").enable();
  window.Promise = require("promise/lib/es6-extensions.js");
}

Object.assign = require("object-assign");
window.URLSearchParams = require("url-search-params");

/**
 * Include Axios
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");

window._ = require("lodash");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

import {legacyAxiosParamsSerializer} from "./legacy_axios_params_serializer";
window.axios.defaults.paramsSerializer = params => legacyAxiosParamsSerializer(params);
// window.dropzone = require("dropzone");

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error(
    "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
  );
}

/**
 * Include VueClipboard
 */
import VueClipboards from "vue-clipboards";
Vue.use(VueClipboards);

import VueResource from "vue-resource";
Vue.use(VueResource);

/**
 * Include VueTables2
 */
import { ClientTable, ServerTable } from "vue-tables-2";
Vue.use(ClientTable);
Vue.use(ServerTable);

/**
 * Include VueScrollTo
 */
var VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

/**
 * Include Toastr notifications
 */
window.toastr = require("toastr");
toastr.options = {
  closeButton: true,
  closeMethod: "fadeOut",
  closeEasing: "linear",
  escapeHtml: true
};

window.moment = require("moment");

window.$ = require("jquery");

// Closest polyfill
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (el.matches(s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
